export const SIDE_SIZES = [70, 60, 50, 40, 30, 20];

export const DEFAULT_SERVER_COLOR_SET = {
  cpu: '#47B4EB',
  memory: '#6C1AE6',
  disk: '#27D9A9',
  rx: '#087DED',
  tx: '#009378',
} as const;
